import { NgIf } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Item } from '../../../../../../../../app/core/shared/item.model';
import { MetadataFieldWrapperComponent } from '../../../../../../../../app/shared/metadata-field-wrapper/metadata-field-wrapper.component';

@Component({
  selector: 'ds-original-publication-item-page-field',
  templateUrl: './original-publication-item-page-field.component.html',
  styleUrls: ['./original-publication-item-page-field.component.scss'],
  standalone: true,
  imports: [MetadataFieldWrapperComponent, NgIf, TranslateModule],
})
/**
 * Renders the bibliographic citation of the original publication
 * followed by its doi reference as a link, e.g.
 *
 *   Besprochene Publikation:
 *   Besley, J. C., & Dudo, A. (2026).
 *   Scientists' public engagement goals: Perceived importance and personal prioritization.
 *   Public Understanding of Science, 35(2), 214-235.
 *   https://doi.org/XXX/YYYY
 *
 */
export class OriginalPublicationItemPageFieldComponent {

  /**
   * The item to display metadata for
   */
  @Input() item: Item;

  /**
   * Label i18n key for the rendered block
   */
  @Input() label = 'item.page.originalPublication';

  /**
   * Metadata field holding the free text bibliographic citation
   */
  @Input() citationField = 'dcterms.bibliographicCitation';

  /**
   * Metadata field holding the link to the original publication
   */
  @Input() referenceField = 'dcterms.isReferencedBy';

  get citation(): string {
    return this.item?.firstMetadataValue(this.citationField)?.trim() ?? '';
  }

  get reference(): string {
    return this.item?.firstMetadataValue(this.referenceField)?.trim() ?? '';
  }

  get hasContent(): boolean {
    return this.citation.length > 0 || this.reference.length > 0;
  }

}
